(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /**
   * LcCarousel — Last Crumb Core Collection inspired carousel
   * Uses Swiper.js with active card tracking and modals
   */
  class LcCarousel {
    constructor(el) {
      this.el = el;
      this.container = el.querySelector('.lc-carousel__container');
      this.swiperEl = el.querySelector('.lc-carousel__swiper');
      this.tabs = Array.from(el.querySelectorAll('.lc-carousel__tab'));
      this.underline = el.querySelector('.lc-carousel__tabsUnderline');
      this.products = Array.from(el.querySelectorAll('.lc-product-card'));

      if (this.products.length < 1) return;

      this.loadFullResolutionImages();
      this.initSwiper();
      this.initTabs();
    }

    loadFullResolutionImages() {
      this.el.querySelectorAll('.lc-product-card__image').forEach(function(img) {
        var src = img.getAttribute('data-src');
        var srcset = img.getAttribute('data-srcset');

        if (src) {
          img.setAttribute('src', src);
        }

        if (srcset) {
          img.setAttribute('srcset', srcset);
        }

        img.classList.remove('blur-up', 'loaded');
      });
    }

    /* ── Swiper with active card tracking ──  */
    initSwiper() {
      var self = this;
      if (typeof Swiper === 'undefined') {
        var check = setInterval(function() {
          if (typeof Swiper !== 'undefined') {
            clearInterval(check);
            self.createSwiper();
          }
        }, 100);
        setTimeout(function() { clearInterval(check); }, 5000);
      } else {
        this.createSwiper();
      }
    }

    createSwiper() {
      var self = this;
      var autoplayEnabled = this.el.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(this.el.dataset.autoplaySpeed, 10) || 5000;

      var swiperConfig = {
        // Last Crumb style: active product high/large, side products lower and half-visible
        slidesPerView: 1.55,
        spaceBetween: 0,
        speed: 650,
        centeredSlides: true,
        loop: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        watchSlidesProgress: true,
        scrollbar: {
          el: this.swiperEl.querySelector('.swiper-scrollbar'),
          draggable: true,
        },
        navigation: {
          nextEl: this.swiperEl.querySelector('.swiper-button-next'),
          prevEl: this.swiperEl.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          0: {
            slidesPerView: 1.25,
            spaceBetween: -40,
            centeredSlides: true
          },
          768: {
            slidesPerView: 1.6,
            spaceBetween: 0,
            centeredSlides: true
          },
          1024: {
            slidesPerView: 2.25,
            spaceBetween: 0,
            centeredSlides: true
          }
        },
        on: {
          init: function() {
            self.updateActiveCard();
          },
          slideChange: function() {
            self.updateActiveCard();
          },
          slideChangeTransitionStart: function() {
            self.updateActiveCard();
          }
        }
      };

      if (autoplayEnabled) {
        swiperConfig.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: true,
        };
      }

      this.swiper = new Swiper(this.swiperEl, swiperConfig);
      // Apply active class synchronously right after swiper creation
      // (on.init can fire too early before internal state is settled)
      var self = this;
      requestAnimationFrame(function() {
        self.updateActiveCard();
      });
    }

    /* ── Update active card class ── */
    updateActiveCard() {
      if (!this.swiper) return;
      this.products.forEach(function(card) {
        if (card.classList.contains('swiper-slide-active')) {
          card.classList.add('lc-product-card-active');
        } else {
          card.classList.remove('lc-product-card-active');
        }
      });
    }

    /* ── Tabs ── */
    initTabs() {
      var self = this;
      this.tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          self.tabs.forEach(function(t) { t.classList.remove('active'); });
          tab.classList.add('active');
          self.updateUnderline(tab);
        });
      });

      var activeTab = this.tabs.find(function(t) { return t.classList.contains('active'); });
      if (activeTab) {
        setTimeout(function() { self.updateUnderline(activeTab); }, 100);
      }
    }

    updateUnderline(tab) {
      if (!this.underline) return;
      this.underline.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      this.underline.style.width = tab.offsetWidth + 'px';
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    }
  }

  // ── Initialize ──
  var instances = [];

  function initCarousels(scope) {
    scope = scope || document;
    var els = scope.querySelectorAll('.lc-carousel');
    els.forEach(function(el) {
      if (el._lcCarousel) return;
      var instance = new LcCarousel(el);
      el._lcCarousel = instance;
      instances.push(instance);
    });
  }

  // Load Swiper if not already loaded
  if (typeof Swiper === 'undefined') {
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = function() { initCarousels(); };
    document.head.appendChild(script);
  } else {
    initCarousels();
  }

  // Shopify section events
  document.addEventListener('shopify:section:load', function(e) {
    var el = document.getElementById('section-' + e.detail.sectionId);
    if (el && el.classList.contains('lc-carousel')) {
      initCarousels(el);
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    var el = document.getElementById('section-' + e.detail.sectionId);
    if (el && el._lcCarousel) {
      el._lcCarousel.destroy();
      delete el._lcCarousel;
    }
  });

  // Re-trigger on window resize for underline
  window.addEventListener('resize', function() {
    instances.forEach(function(inst) {
      var activeTab = inst.tabs.find(function(t) { return t.classList.contains('active'); });
      if (activeTab) inst.updateUnderline(activeTab);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
